(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jl-managed-category-directory"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('jl-managed-category-browser'))customElements.define('jl-managed-category-browser',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;
  this.dataset.ready='true';
  const rail=this.querySelector('[data-jl-directory-nav]');
  const holder=this.querySelector('[data-jl-directory-panels]');
  const groups=[...holder.querySelectorAll(':scope > [data-jl-directory-group]')];
  groups.forEach(group=>{
   if(group.dataset.kind==='link'){rail.append(group);return;}
   const panel=group.querySelector('[data-jl-category-panel]');
   if(!panel)return;
   const tab=document.createElement('a');tab.href='#'+panel.id;tab.textContent=group.dataset.title;tab.dataset.jlCategoryTarget=panel.id;tab.dataset.jlGroupOwner=group.dataset.groupId;rail.append(tab);
  });
  const links=[...rail.querySelectorAll('[data-jl-category-target]')];
  const panels=[...holder.querySelectorAll('[data-jl-category-panel]')];
  const activate=id=>{links.forEach(a=>{if(a.dataset.jlCategoryTarget===id)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});panels.forEach(p=>p.hidden=p.id!==id);};
  rail.addEventListener('click',event=>{const a=event.target.closest('[data-jl-category-target]');if(!a||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();activate(a.dataset.jlCategoryTarget);});
  this.addEventListener('shopify:block:select',event=>{const group=event.target.closest('[data-jl-directory-group]');const panel=group?.querySelector('[data-jl-category-panel]');if(panel)activate(panel.id);});
  if(links.length){const hash=location.hash.slice(1);activate(panels.some(p=>p.id===hash)?hash:links[0].dataset.jlCategoryTarget);}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jl-shop"] && !Shopify.designMode) return;
  try {
    
if (!window.jlShopSortDismiss) {
  window.jlShopSortDismiss = true;
  const updateWearFilter = (range, active) => {
    const group = range.closest('[data-jl-wear-filter]');
    const hidden = group.querySelector('[data-jl-wear-value]');
    const output = group.querySelector('[data-jl-wear-output]');
    hidden.disabled = !active;
    hidden.value = active ? range.value : '';
    const label = active ? range.getAttribute('data-level-' + range.value) : range.dataset.any;
    output.textContent = label || '';
    range.setAttribute('aria-valuetext', label || '');
  };
  document.addEventListener('input', event => {
    if (event.target.matches('[data-jl-wear-range]')) updateWearFilter(event.target, true);
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-jl-filter-color-master]')) return;
    const group = event.target.closest('[data-jl-filter-color-group]');
    group.querySelectorAll('[data-jl-filter-color-extra]').forEach(input => { input.disabled = !event.target.checked; });
  });
  document.addEventListener('pointerdown', event => {
    if (event.target.matches('[data-jl-wear-range]')) updateWearFilter(event.target, true);
  });
  document.addEventListener('keydown', event => {
    if (event.target.matches('[data-jl-wear-range]') && ['Home','End','Enter',' '].includes(event.key)) updateWearFilter(event.target, true);
  });
  document.addEventListener('click', event => {
    const clear = event.target.closest('[data-jl-wear-clear]');
    if (clear) updateWearFilter(clear.closest('[data-jl-wear-filter]').querySelector('[data-jl-wear-range]'), false);
    const close = event.target.closest('[data-jl-filter-close]');
    if (close) {
      const menu = close.closest('.jl-shop__filter-menu');
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!menu.matches('.jl-shop__filter-menu')) return;
    document.documentElement.classList.toggle('jl-shop-filter-open', menu.open);
    if (menu.open) menu.querySelector('.jl-shop__filter-close')?.focus();
  }, true);
  document.addEventListener('keydown', event => {
    const menu = document.querySelector('.jl-shop__filter-menu[open]');
    if (!menu || event.key !== 'Tab') return;
    const focusable = [...menu.querySelectorAll('.jl-shop__filter-panel a[href], .jl-shop__filter-panel button:not([disabled]), .jl-shop__filter-panel input:not([disabled]), .jl-shop__filter-panel summary')].filter(el => el.offsetParent !== null);
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable[focusable.length - 1].focus(); }
    else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) { event.preventDefault(); focusable[0].focus(); }
  });
  document.addEventListener('error', event => {
    if (event.target.matches?.('.jl-shop__second')) event.target.hidden = true;
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll('.jl-shop__sort-menu[open], .jl-shop__filter-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.jl-shop__sort-menu[open], .jl-shop__filter-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
if(!customElements.get('jl-category-browser'))customElements.define('jl-category-browser',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;
  this.dataset.ready='true';
  const links=[...this.querySelectorAll('[data-jl-category-target]')];
  const panels=[...this.querySelectorAll('[data-jl-category-panel]')];
  const activate=id=>{links.forEach(a=>{if(a.dataset.jlCategoryTarget===id)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});panels.forEach(p=>p.hidden=p.id!==id);};
  links.forEach(a=>a.addEventListener('click',event=>{if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();activate(a.dataset.jlCategoryTarget);}));
  if(links.length)activate(links[0].dataset.jlCategoryTarget);
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jl-site-footer')) {
  customElements.define('jl-site-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.mobile = matchMedia('(max-width: 749px)');
      const menus = [...this.querySelectorAll('.jl-footer-menu')];
      const sync = () => menus.forEach(menu => {
        menu.open = !this.mobile.matches;
        menu.querySelector('summary').tabIndex = this.mobile.matches ? 0 : -1;
      });
      this.mobile.addEventListener('change', sync, { signal: this.controller.signal });
      menus.forEach(menu => menu.querySelector('summary').addEventListener('click', event => {
        if (!this.mobile.matches) event.preventDefault();
      }, { signal: this.controller.signal }));
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jl-product-carousel')) {
  customElements.define('jl-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.jl-product-track');
      this.navigation = this.querySelector('.jl-product-navigation');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.currentLabel = this.querySelector('[data-current]');
      this.totalLabel = this.querySelector('[data-total]');
      if (!this.track.querySelector('.jl-product-column')) {
        const cards = [...this.track.children];
        for (let i = 0; i < cards.length; i += 2) {
          const column = document.createElement('div');
          column.className = 'jl-product-column';
          this.track.append(column);
          cards.slice(i, i + 2).forEach(card => column.append(card));
        }
      }
      this.cards = [...this.track.children];
      this.track.style.setProperty('--jl-desktop-columns', Math.min(4, this.cards.length) || 1);
      this.track.style.setProperty('--jl-tablet-columns', Math.min(3, this.cards.length) || 1);
      this.wantsAutoplay = this.dataset.autoplay === 'true' && this.cards.length > 1;
      this.loop = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(1000, Number(this.dataset.interval) || 2000);
      this.resumeDelay = Math.max(1000, Number(this.dataset.resumeDelay) || 2000);
      this.positions = [0];
      this.page = 0;
      this.hovered = false;
      this.inView = false;
      this.pressed = false;
      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.normalize(), 140);
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true, signal });
      this.track.addEventListener('scrollend', () => this.normalize(), { signal });
      this.navigation.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (button && !button.disabled) {
          this.go(this.page + Number(button.dataset.direction));
          this.schedule(this.resumeDelay);
        }
      }, { signal });
      this.track.addEventListener('keydown', event => {
        const keys = { ArrowLeft: this.page - 1, ArrowRight: this.page + 1, Home: 0, End: this.loop ? this.cards.length - 1 : this.positions.length - 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        this.go(keys[event.key]);
        this.schedule(this.resumeDelay);
      }, { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        clearTimeout(this.autoTimer);
      }, { signal });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.schedule(this.resumeDelay);
      }, { signal });
      this.addEventListener('pointerdown', () => {
        this.pressed = true;
        clearTimeout(this.autoTimer);
      }, { signal });
      const resume = () => { this.pressed = false; this.schedule(this.resumeDelay); };
      window.addEventListener('pointerup', resume, { signal });
      window.addEventListener('pointercancel', resume, { signal });
      this.track.addEventListener('wheel', () => this.schedule(this.resumeDelay), { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.schedule(this.resumeDelay), { signal });
      this.reducedMotion.addEventListener('change', () => this.schedule(this.resumeDelay), { signal });
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.positions.length < 2) return;
        this.drag = { id: event.pointerId, x: event.clientX, start: this.track.scrollLeft, moved: false };
        this.suppressClick = false;
      }, { signal });
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const distance = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(distance) < 6) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        this.track.scrollLeft = this.drag.start - distance;
      }, { signal });
      const finishDrag = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const drag = this.drag;
        this.drag = null;
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.track.classList.remove('is-dragging');
        if (drag.moved) {
          this.suppressClick = true;
          this.normalize();
          this.update();
          this.go(this.page);
        }
        this.schedule(this.resumeDelay);
      };
      this.track.addEventListener('pointerup', finishDrag, { signal });
      this.track.addEventListener('pointercancel', finishDrag, { signal });
      this.track.addEventListener('lostpointercapture', finishDrag, { signal });
      this.track.addEventListener('click', event => {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }
      }, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.track);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule(this.interval);
      }, { threshold: 0.15 });
      this.intersectionObserver.observe(this);
      this.track.querySelectorAll('img').forEach(image => { image.draggable = false; });
      this.measure();
    }
    measure() {
      const first = this.cards[0];
      const last = this.cards[this.cards.length - 1];
      const naturalWidth = first && last ? last.offsetLeft - first.offsetLeft + last.offsetWidth : 0;
      const shouldLoop = this.wantsAutoplay && naturalWidth > this.track.clientWidth + 1;
      if (shouldLoop !== this.loop) {
        this.track.querySelectorAll('[data-carousel-clone]').forEach(clone => clone.remove());
        this.loop = shouldLoop;
      if (this.loop) {
        for (let repeat = 0; repeat < 2; repeat++) {
          for (const card of this.cards) {
            const clone = card.cloneNode(true);
            clone.dataset.carouselClone = '';
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
            clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(element => element.tabIndex = -1);
            this.track.append(clone);
          }
        }
      }
        this.track.scrollLeft = 0;
        this.querySelector('.jl-product-pagination').setAttribute('aria-live', this.loop ? 'off' : 'polite');
      }
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.positions = [0];
      if (first && maximum > 1) {
        const candidates = this.loop ? [...this.cards, this.track.querySelector('[data-carousel-clone]')] : this.cards;
        for (const card of candidates) {
          const position = Math.min(maximum, Math.max(0, card.offsetLeft - first.offsetLeft));
          if (position - this.positions[this.positions.length - 1] > 1) this.positions.push(position);
        }
        if (!this.loop && maximum - this.positions[this.positions.length - 1] > 1) this.positions.push(maximum);
      }
      this.cycle = this.loop ? this.positions[this.positions.length - 1] : 0;
      this.navigation.hidden = this.positions.length <= 1;
      this.track.classList.toggle('is-draggable', this.positions.length > 1);
      this.totalLabel.textContent = this.loop ? this.cards.length : this.positions.length;
      this.update();
      this.schedule(this.interval);
    }
    update() {
      let left = this.track.scrollLeft;
      if (this.loop && this.cycle) left %= this.cycle;
      const options = this.loop ? this.positions.slice(0, -1) : this.positions;
      this.page = options.reduce((best, position, index) => Math.abs(position - left) < Math.abs(options[best] - left) ? index : best, 0);
      this.currentLabel.textContent = this.page + 1;
      this.previous.disabled = !this.loop && this.page === 0;
      this.next.disabled = !this.loop && this.page === this.positions.length - 1;
    }
    normalize() {
      if (!this.loop || !this.cycle || this.drag) return;
      if (this.track.scrollLeft >= this.cycle - 1) {
        this.track.scrollTo({ left: this.track.scrollLeft % this.cycle, behavior: 'instant' });
        this.update();
      }
    }
    go(index) {
      if (this.loop) {
        this.normalize();
        if (index < 0) {
          this.track.scrollTo({ left: this.cycle, behavior: 'instant' });
          index = this.cards.length - 1;
        }
        index = Math.min(this.cards.length, Math.max(0, index));
      } else index = Math.min(this.positions.length - 1, Math.max(0, index));
      this.track.scrollTo({ left: this.positions[index], behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
    }
    schedule(delay) {
      clearTimeout(this.autoTimer);
      if (!this.loop || !this.inView || document.hidden || this.hovered || this.pressed || this.reducedMotion.matches) return;
      this.autoTimer = setTimeout(() => {
        this.normalize();
        this.update();
        this.go(this.page + 1);
        this.schedule(this.interval);
      }, delay);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.autoTimer);
      clearTimeout(this.settleTimer);
      this.track?.querySelectorAll('[data-carousel-clone]').forEach(clone => clone.remove());
      this.controller = null;
      this.drag = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
